import { useTranslation } from 'react-i18next';
// @ts-ignore
import { Box, PageHeader } from '@zolteam/zol-admin-ui';
// Components

/**
 * Home view component
 * @returns {JSX.Element} The Home component
 */
function Home() {
  // Hooks
  const { t } = useTranslation();

  return (
    <Box direction="column" gap="s" className="padding-l">
      <PageHeader
        title={(
          <h1 className="h1-default" style={{ fontWeight: 'bold' }}>
            {t('home.title')}
          </h1>
        )}
      />
    </Box>
  );
}

export default Home;
